<p-confirmDialog key="edit" [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<!--School Select-->
<div class="MainMenu">
	<div class="Center2ColMenu">
		<label style="margin: 0">School:</label>
		<select [disabled]="EnableSchoolChange() == false" class="form-control" [(ngModel)]="SchoolID">
			<option *ngFor="let r of lstSchool" [ngValue]="r.SchoolID">
				{{ r.SchoolName }}
			</option>
		</select>
	</div>
</div>

<!--Menu Top-->
<div class="MainMenu TopMargin">
	<div class="NameMenu">
		<label>First Name:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="FirstName" />

		<label>Middle Initial:</label>
		<input [disabled]="EnableEdit() == false" class="form-control MiddleInitial" type="text" maxlength="1" [(ngModel)]="MInitial" />

		<label>Last Name:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="LastName" />
	</div>

	<div class="Main2Grid">
		<!--L Col-->
		<div class="Grid2Col">
			<label>Title:</label>
			<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="Title" />

			<label>DOB:</label>
			<p-calendar [disabled]="EnableEdit() == false" showIcon="true" showButtonBar="true" [(ngModel)]="DOB" name="DOB"></p-calendar>

			<label>Gender:</label>
			<select [disabled]="EnableEdit() == false" class="form-control" [(ngModel)]="Gender">
				<option *ngFor="let r of lstGender" [ngValue]="r.ID">
					{{ r.Desc }}
				</option>
			</select>

			<label>Staff ID:</label>
			<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="StaffID" />
		</div>

		<!--R Col-->
		<div class="Grid2Col">
			<label>Staff Type:</label>
			<select [disabled]="EnableEdit() == false" class="form-control" [(ngModel)]="StaffType">
				<option *ngFor="let r of lstStaffType" [ngValue]="r.PersonTypeID">
					{{ r.PersonTypeDesc }}
				</option>
			</select>

			<label>SSN:</label>
			<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="SSN" />

			<label>Ethnicity</label>
			<select [disabled]="EnableEdit() == false" class="form-control" [(ngModel)]="Ethnicity">
				<option *ngFor="let r of lstEthnicity" [ngValue]="r.EthnicityID">
					{{ r.EthnicityDesc }}
				</option>
			</select>

			<label>Status</label>
			<select [disabled]="EnableEdit() == false" class="form-control" [(ngModel)]="Status">
				<option *ngFor="let r of lstStatus" [ngValue]="r.ID">
					{{ r.Desc }}
				</option>
			</select>
		</div>
	</div>
</div>

<!--Menu Bottom-->
<div class="MainMenu TopMargin">
	<div class="Grid4Col">
		<label>Address 1:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="Address1" />

		<label>Address 2:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="Address2" />
	</div>

	<div class="Grid6Col TopMargin">
		<label>City:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="City" />

		<label>State:</label>
		<input [disabled]="EnableEdit() == false" class="form-control StateText" type="text" maxlength="2" [(ngModel)]="State" />

		<label>Zip:</label>
		<input [disabled]="EnableEdit() == false" class="form-control ZipText" type="text" maxlength="10" [(ngModel)]="Zip" />
	</div>

	<div class="Grid4Col TopMargin">
		<label>Work Phone:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="WPhone" />

		<label>Cell Phone:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="CPhone" />

		<label>Home Phone:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="HPhone" />

		<label>Fax:</label>
		<input [disabled]="EnableEdit() == false" class="form-control" type="text" [(ngModel)]="Fax" />
	</div>

	<div class="Center2ColMenu TopMargin">
		<label>Email:</label>
		<input [disabled]="EnableEditEmail() == false" class="form-control" type="text" [(ngModel)]="Email" />
	</div>
</div>

<div class="TopMargin" *ngIf="EnableEdit() == false && EnableEditEmail() == false && EnableStaffEmail >= 0">
	<!-- -1 For still loading. 0 = Enable, 1 = Disable because email is imported -->
	<div name="ImportWarningNoEmail" class="alert alert-warning">This staff member is maintained through import. No values can be changed</div>
</div>

<div class="TopMargin" *ngIf="EnableEdit() == false && EnableEditEmail() == true && EnableStaffEmail >= 0">
	<div name="ImportWarningEmail" class="alert alert-warning">This staff member is maintained through import. Only email can be changed</div>
</div>

<!--Buttons-->
<div class="Buttons">
	<button [disabled]="EnableEdit() == false && EnableEditEmail() == false" class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>

<!--Error Message-->
<div class="TopMargin">
	<div name="errorMessage" *ngIf="errorMessage" class="alert alert-danger">
		{{ errorMessage }}
	</div>
</div>
